import {ReportsActionType, SystemActionType} from "../../actions";
import LocalStorage from "../../utils/LocalStorage";
import { v4 as uuidv4 } from 'uuid';

const DefaultSystemState = {
    haveCard: false,
    defaultCard:null,
    cardList:[],
    commodityList:[],
    commodityInfo: {},
    sizeCostList:[],
    sizeCostInfo: {},
    total:0,
    subRoleList:[],
    userList:[],
    storageFeeAuthorityList:[],
    storageFeeAuthorityInfo:{},
    storageFeeAuthorityTotal:0,
}

export const systemReducer = (
    state = DefaultSystemState,
    action = {}) =>
{
    switch (action.type) {
        case SystemActionType.Card_Assignment:
            LocalStorage.setItem('card',action?.payload?.paymentMethodList?.length > 0)

            return { ...state, haveCard: action?.payload?.paymentMethodList?.length > 0 , defaultCard: action?.payload?.paymentMethodList?.length > 0?{...action?.payload?.paymentMethodList[0]}:null,cardList:action?.payload?.paymentMethodList }

        case SystemActionType.Check_Card:
            LocalStorage.setItem('card',action?.payload)

            return { ...state, haveCard: action?.payload}

        case SystemActionType.Set_Card:
            LocalStorage.setItem('card',action.payload)
            return { ...state, haveCard: action.payload}

        case SystemActionType.Commodity_List:
            return { ...state, commodityList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, listId: uuidv4() }

                }):[], total: action.payload.total?action.payload.total:0}

        case SystemActionType.Commodity_Info:
            return { ...state, commodityInfo: action.payload.data}

        case SystemActionType.Commodity_Reset:
            return { ...state, commodityInfo: {}}

        case SystemActionType.Size_Cost_List:
            return { ...state, sizeCostList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, listId: uuidv4() }
                }):[], total: action.payload.total?action.payload.total:0}

        case SystemActionType.Size_Cost_Info:
            return { ...state, sizeCostInfo: action.payload.data}

        case SystemActionType.Size_Cost_Reset:
            return { ...state, sizeCostInfo: {}}

        case SystemActionType.Sub_Roles_List:
            return { ...state, subRoleList: action.payload}

        case SystemActionType.Users_Filter:
            return { ...state, userList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }
                }):[], total: action.payload.total?action.payload.total:0}

        case SystemActionType.Storage_FeeAuthority_List:
            return { ...state, storageFeeAuthorityList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, listId: uuidv4() }
                }):[], storageFeeAuthorityTotal: action.payload.total?action.payload.total:0}

        case SystemActionType.Storage_FeeAuthority_Info:
            return { ...state, storageFeeAuthorityInfo: action.payload.data}

        case SystemActionType.Storage_FeeAuthority_Reset:
            return { ...state, storageFeeAuthorityInfo: {}}


        default:
            return state;

    }

}

export default systemReducer